import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import { useClassroomDoughnuts } from './doughnut-inner-hooks';
import {
  MOUSE_STATE_LEAVE,
  doughnutWidth,
  doughnutGap,
  STUDENT,
  GROUP,
  CLASSROOM
} from '../../../../../../helpers/utils';
import ContextModal from '../doughnut-tooltip/doughnut-tooltip';
import { ContextModalContent } from '../doughnut-chart.styled';

const DoughnutsInner = ({
  i18n,
  classroomPercent,
  groupPercent,
  studentPercent,
  resultType,
  groupActivitiesCount,
  classActivitiesCount,
  completedActivitiesCount,
  totalActivitiesCount
}) => {
  const [AllDoughnuts, { doughnutType, mouseState }] = useClassroomDoughnuts({
    resultType,
    studentPercent,
    groupPercent,
    groupActivitiesCount,
    classroomPercent
  });
  const modalWidth = 220;
  const classContextPos = 160;
  const contextOffset =
    doughnutWidth + (resultType === STUDENT ? doughnutGap / 2 : doughnutGap);
  const contextModalYPos = classContextPos - doughnutType * contextOffset;
  const percentages = [classroomPercent, groupPercent, studentPercent];

  const renderTooltip = () => {
    switch (doughnutType) {
      case STUDENT:
        return (
          <ContextModalContent data-testid="hover-context">
            {`${percentages[doughnutType]}% `}
            {i18n._(t('doughnut-tooltip-average-from')`average from`)}
            {` ${completedActivitiesCount} `}
            {i18n._(
              t(
                'doughnut-tooltip-activities-completed-out-of'
              )`activities completed out of`
            )}
            {` ${totalActivitiesCount}`}
          </ContextModalContent>
        );
      case GROUP:
        return (
          <ContextModalContent data-testid="hover-context">
            {`${percentages[doughnutType]}% `}
            {i18n._(t('doughnut-tooltip-average-from')`average from`)}
            {` ${groupActivitiesCount} `}
            {i18n._(
              t('doughnut-tooltip-activities-completed')` activities completed`
            )}
          </ContextModalContent>
        );
      case CLASSROOM:
        return (
          <ContextModalContent data-testid="hover-context">
            {`${percentages[doughnutType]}% `}
            {i18n._(t('doughnut-tooltip-average-from')`average from`)}
            {` ${classActivitiesCount} `}
            {i18n._(
              t('doughnut-tooltip-activities-completed')` activities completed`
            )}
          </ContextModalContent>
        );
      default:
        return null;
    }
  };
  return (
    <Fragment>
      <svg
        data-testid="content"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        height="160"
        width="160"
        className="doughnut-svg"
      >
        <AllDoughnuts />
      </svg>
      <ContextModal
        show={mouseState !== MOUSE_STATE_LEAVE}
        positionArrow={modalWidth / 2}
        positionX={0}
        positionY={contextModalYPos}
        fixedParent
        contextTheme="standard"
        name={renderTooltip()}
        modalWidth={modalWidth}
      />
    </Fragment>
  );
};

DoughnutsInner.propTypes = {
  i18n: PropTypes.object,
  resultType: PropTypes.number,
  studentPercent: PropTypes.number,
  completedActivitiesCount: PropTypes.number,
  totalActivitiesCount: PropTypes.number,
  groupPercent: PropTypes.number,
  groupActivitiesCount: PropTypes.number,
  classroomPercent: PropTypes.number,
  classActivitiesCount: PropTypes.number
};

export default DoughnutsInner;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/doughnut-chart/doughnut-inner/doughnut-inner.js